import { checkGate, FEATURE_GATES } from '@/lib/statsig';
import { Countries } from '@/types/Countries';
import { TransformedAssetCategoryResult } from '@/types/TransformedAssetCategoryResults';
import { SubscriptionType } from '@/utils/fetch/fetchProductSubscriptionByRegion';
import { getFormerSignUpFee } from '@/utils/getFormerSignUpFee';
import { getPromoLabelTranslationKey } from '@/utils/getPromoLabelText';
import { FormValues } from '../components/FormConfig/formData';
import { getCurrentSubscriptionIsFlexible } from './getCurrentSubscriptionDuration';

export const getCurrentSubscriptionPromoLabelI18nKey = (
  country: Countries,
  product: TransformedAssetCategoryResult,
  durationMonths?: FormValues['durationMonths'],
  subscriptionCode?: SubscriptionType['code']
) => {
  const isFlexible = getCurrentSubscriptionIsFlexible(durationMonths);
  const hasSpecialOffer = Boolean(product.rates.specialOffer);
  const hasReducedPrice = checkGate(
    {
      custom: {
        country,
        product: product.productConfig.id,
      },
    },
    FEATURE_GATES.priceReduction
  );
  const hasNoSignUpFee = checkGate(
    {
      custom: {
        country,
        product: product.productConfig.id,
      },
    },
    FEATURE_GATES.noSignUpFee
  );
  const formerSignUpFee = getFormerSignUpFee(country, subscriptionCode);

  const isPowerPlusProduct = product.productConfig.id === 'power-plus';
  const showPromoLabel =
    (hasSpecialOffer && !isFlexible) ||
    hasReducedPrice ||
    (hasNoSignUpFee && formerSignUpFee) ||
    isPowerPlusProduct;

  return showPromoLabel
    ? getPromoLabelTranslationKey(
        product.productConfig.translationKey,
        !!hasReducedPrice,
        !!hasNoSignUpFee,
        isPowerPlusProduct
      )
    : '';
};
